import React, { Fragment } from "react";
import { SelectInput, TextInput } from "react-admin";
import { Suspension } from "../../../common/data/service-proxies";
import { ProtectedElement } from "../../common/field-permissions/ProtectedElement";

interface InnerTrailerFormProps {
  years: {
    id: number;
    name: string;
  }[];
  suspensions: {
    id: Suspension;
    name: string;
  }[];
}

export const InnerTrailerForm = ({
  years,
  suspensions,
  ...rest
}: InnerTrailerFormProps) => {
  return (
    <Fragment>
      <ProtectedElement
        source="vin"
        label="resources.admin-trailers.labels.vin"
        {...rest}>
        <TextInput source="vin" />
      </ProtectedElement>
      <ProtectedElement
        source="year"
        label="resources.admin-trailers.labels.year"
        {...rest}>
        <SelectInput choices={years} />
      </ProtectedElement>
      <ProtectedElement
        source="make"
        label="resources.admin-trailers.labels.make"
        {...rest}>
        <TextInput source="make" />
      </ProtectedElement>
      <ProtectedElement
        source="licensePlate"
        label="resources.admin-trailers.labels.licencePlate"
        {...rest}>
        <TextInput source="licensePlate" />
      </ProtectedElement>
      <ProtectedElement
        source="suspension"
        label="resources.admin-trailers.labels.suspension"
        {...rest}>
        <SelectInput choices={suspensions} />
      </ProtectedElement>
    </Fragment>
  );
};
